<template>
  <div>
    <!-- Navigation -->
    <navigation
      @prev="$emit('prev')"
      @next="$emit('next')"
      :activeStepIndex="activeStepIndex"
      :$v="$v"
      :processing-api="processingApi"
    />

    <!-- Form -->
    <div class="form-group">
      <label class="black title-bold" for="nome">{{$t('whats_your_name')}}</label>
      <div class="error mt-n2" v-if="$v.profile.Name1.$error">
        <span class="error " v-if="!$v.profile.Name1.required">{{$t('name') + $t('is_required')}}</span>
        <span class="error mt-n2" v-else-if="!$v.profile.Name1.minLength">{{ $t('name') + $t('min-length') }} {{$v.profile.Name1.$params.minLength.min}} {{$t('letters')}}</span>
      </div>
      <input
        type="text"
        class="form-control"
        id="name1"
        :placeholder="$t('type_here')"
        v-model="profile.Name1"
        @keydown.enter="focusOn('name2')"
        @blur="$v.profile.Name1.$touch()"
      />

      <label class="black title-bold" for="nome">{{$t('how_wish_to_be_called')}}</label>
      <div class="error mt-n2" v-if="$v.profile.SocialName.$error">
        <span class="error " v-if="!$v.profile.SocialName.required">{{$t('nickname') + $t('is_required')}}</span>
        <span class="error mt-n2" v-else-if="!$v.profile.SocialName.minLength">{{$t('nickname') + $t('min_length')}} {{$v.profile.SocialName.$params.minLength.min}} {{$t('letters')}}</span>
      </div>
      <input
        type="text"
        class="form-control"
        id="socialName"
        :placeholder="$t('type_here')"
        v-model="profile.SocialName"
        @keyup.enter="goToNextStep"
        @blur="$v.profile.SocialName.$touch()"
      />
    </div>

    <!-- Button -->
    <section class="row">
      <div class="col-12 mt-5 mx-auto col-md-6">
        <button
          :style="
            style.surveyBtnColor
              ? { backgroundColor: style.surveyBtnColor }
              : { backgroundColor: style.homeBtnColor }
          "
          type="submit"
          class="w-100 btn btn-primary btn-block my-3"
          @click="goToNextStep"
          :disabled="$v.$invalid"
        >
          {{ $t('advance')}}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="processingApi"
          ></span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {minLength, required} from 'vuelidate/lib/validators'
import Navigation from "@/components/registration/components/Navigation";

export default {
  name: "NameAndSocialAName",
  components: {Navigation},
  props: {
    profile: {
      type: Object,
      required: true
    },
    processingApi: {
      type: Boolean,
      required: true
    },
    activeStepIndex: {
      type: Number,
      required: true
    }
  },
  validations: {
    profile: {
      Name1: {
        required,
        minLength: minLength(2)
      },
      SocialName: {
        required,
        minLength: minLength(2)
      }
    }
  },
  computed: {
    style() {
      return this.$store.state.template.style;
    },
  },
  mounted() {
    if (this.activeStepIndex !== 0) this.focusOn('name1')
  },
  methods: {
    focusOn(el) {
      document.getElementById(el).focus();
    },
    goToNextStep() {
      if (!this.$v.$invalid) this.$emit('next')
    }
  }
}
</script>
